import { z } from 'zod';
import { lastKnownLocationSchema } from '../../common/last-known-location.schema';

/**
 * `Vehicle.meta` — agent-facing signal layer on the Vehicle.
 *
 * Mirrors `Driver.meta.lastKnownLocation` but scoped to the
 * Vehicle document itself so the fleet god-view can render a
 * vehicle-centric map (`vehicles.find({ 'meta.lastKnownLocation.point': { $near: ... } })`)
 * without a Driver join. See `docs/ai/user-signals.md`.
 *
 * Writes fire when the ping's user is a Driver AND that Driver
 * is currently assigned to a Vehicle (`Driver.vehicle._id` or
 * `Vehicle.driver.userId`).
 */
export const vehicleMetaSchema = z.object({
  /**
   * Last GPS-quality point for this Vehicle. Only writers with a
   * `source` of `app_foreground` / `app_background` / `iot_gps`
   * update this.
   */
  lastKnownLocation: lastKnownLocationSchema.optional(),
});
export type VehicleMeta = z.infer<typeof vehicleMetaSchema>;
